import { apiClient } from '@/shared/services/client'
import type {
  Area,
  AreaGrupo,
  AreaListItem,
  AreaUsuario,
  AreaCreateInput,
  AreaUpdateInput,
  PaginatedAreas,
  AreasFilters,
} from '@/modules/users/types/area'

// ============================================================================
// Areas CRUD
// ============================================================================

export async function getAreas(filters?: AreasFilters): Promise<PaginatedAreas> {
  const response = await apiClient.get<PaginatedAreas>('/areas/', { params: filters })
  return response.data
}

export async function getAllAreas(): Promise<AreaListItem[]> {
  const response = await apiClient.get<AreaListItem[]>('/areas/all/')
  return response.data
}

export async function getArea(areaId: number): Promise<Area> {
  const response = await apiClient.get<Area>(`/areas/${areaId}/`)
  return response.data
}

export async function createArea(data: AreaCreateInput): Promise<Area> {
  const response = await apiClient.post<Area>('/areas/', data)
  return response.data
}

export async function updateArea(areaId: number, data: AreaUpdateInput): Promise<Area> {
  const response = await apiClient.put<Area>(`/areas/${areaId}/`, data)
  return response.data
}

export async function deleteArea(areaId: number): Promise<{ message: string; success: boolean }> {
  const response = await apiClient.delete(`/areas/${areaId}/`)
  return response.data
}

export async function toggleAreaActive(areaId: number): Promise<Area> {
  const response = await apiClient.post<Area>(`/areas/${areaId}/toggle-active/`)
  return response.data
}

// ============================================================================
// Area Users
// ============================================================================

export async function getAreaUsers(areaId: number): Promise<AreaUsuario[]> {
  const response = await apiClient.get<AreaUsuario[]>(`/areas/${areaId}/users/`)
  return response.data
}

// ============================================================================
// Area Groups
// ============================================================================

export async function getAreaGroups(areaId: number): Promise<AreaGrupo[]> {
  const response = await apiClient.get<AreaGrupo[]>(`/areas/${areaId}/groups/`)
  return response.data
}

export async function addGroupToArea(
  areaId: number,
  groupId: number
): Promise<{ message: string; success: boolean }> {
  const response = await apiClient.post(`/areas/${areaId}/add-group/${groupId}/`)
  return response.data
}

export async function removeGroupFromArea(
  areaId: number,
  groupId: number
): Promise<{ message: string; success: boolean }> {
  const response = await apiClient.delete(`/areas/${areaId}/remove-group/${groupId}/`)
  return response.data
}

// ============================================================================
// Area User Assignment
// ============================================================================

export async function assignUserToArea(
  areaId: number,
  userId: number
): Promise<{ message: string; success: boolean }> {
  const response = await apiClient.post(`/areas/${areaId}/assign-user/${userId}/`)
  return response.data
}

export async function removeUserFromArea(
  areaId: number,
  userId: number
): Promise<{ message: string; success: boolean }> {
  const response = await apiClient.delete(`/areas/${areaId}/remove-user/${userId}/`)
  return response.data
}
